import {NgModule} from '@angular/core';

import {HomeComponent} from './home.component';
import {HomeMateriaCardComponent} from './home-materia-card/home-materia-card.component';
import {CommonModule} from '@angular/common';
import {GLMMaterialDesignModule} from '../_components/material-design/material-design.module';
import {DynamicBarModule} from '../_components/dynamic-bar/dynamic-bar.module';
import {CustomPipesModule} from '../_pipes/custom-pipes.module';
import {HomeBarraComponent} from './home-barra.component';
import {HomeService} from './home.service';
import {RouterModule} from '@angular/router';
import {GLMAppPipesModule} from '../_modules/_pipes/app-glm-pipes.module';
import {NotificacionesModule} from '../_modules/notificaciones/notificaciones.module';
import { GlmReconocimientoCardModule } from 'src/app/_components/glm-reconocimiento-card/glm-reconocimiento-card.module';
import { PersonaCardModule } from '../_modules/persona-card/persona-card.module';
import { GlmMateriasCardModule } from 'src/app/_components/glm-materias-card/glm-materias-card.module';
import { ImageErrorDirective } from '../_directives/ui-image-error.directive';
import { PlataformasComponent } from '../_tools/plataformas/plataformas.component';


@NgModule({
  imports: [
    CommonModule,
    GLMMaterialDesignModule,
    DynamicBarModule,
    CustomPipesModule,
    RouterModule,
    GLMAppPipesModule.forRoot(),
    NotificacionesModule,
    GlmReconocimientoCardModule,
    PersonaCardModule,
    GlmMateriasCardModule,
    ImageErrorDirective,
    PlataformasComponent,
  ],
  exports: [],
  declarations: [
    HomeComponent,
    HomeBarraComponent,
    HomeMateriaCardComponent,
  ],
  providers: [
    HomeService
  ],
})
export class HomeModule {
}
